import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const OrgStructureForm = ({ onSuccess, editData }) => {

  const [form, setForm] = useState({
    SectionCode: "CM",
    Title: "",
    PersonName: "",
    Designation: "",
    Message: "",
    SortOrder: 0
  });

  const [photo, setPhoto] = useState(null);
  const [oldPhoto, setOldPhoto] = useState(null);

  useEffect(() => {
    if (editData) {
      setForm({
        SectionCode: editData.SectionCode,
        Title: editData.Title,
        PersonName: editData.PersonName,
        Designation: editData.Designation,
        Message: editData.Message || "",
        SortOrder: editData.SortOrder || 0
      });

      setOldPhoto(editData.PhotoPath);
      setPhoto(null);
    }
  }, [editData]);

  const getPreviewUrl = () => {
    if (photo) {
      return URL.createObjectURL(photo);
    }
    if (oldPhoto) {
      return `${REACT_APP_API_URL}${oldPhoto}`;
    }
    return null;
  };

  const submit = async (e) => {
    e.preventDefault();

    const fd = new FormData();

    if (editData?.OrgID) {
      fd.append("OrgID", editData.OrgID);
    }

    Object.keys(form).forEach(key => {
      fd.append(key, form[key]);
    });

    if (photo) {
      fd.append("photo", photo);
    } else if (oldPhoto) {
      fd.append("PhotoPath", oldPhoto);
    }

    await axios.post(
      `${REACT_APP_API_URL}api/dashboard/admin/org-structure`,
      fd
    );

    alert("Saved Successfully");
    onSuccess();
  };

  return (
    <form onSubmit={submit}>

      <select
        className="form-select mb-2"
        value={form.SectionCode}
        onChange={e => setForm({ ...form, SectionCode: e.target.value })}
      >
        <option value="CM">Chief Minister</option>
        <option value="MIN">Minister</option>
        <option value="DEPT">Department Head</option>
        <option value="JTDC">JTDC Head</option>
      </select>

      <input
        className="form-control mb-2"
        placeholder="Title"
        value={form.Title}
        onChange={e => setForm({ ...form, Title: e.target.value })}
      />

      <input
        className="form-control mb-2"
        placeholder="Name"
        value={form.PersonName}
        onChange={e => setForm({ ...form, PersonName: e.target.value })}
      />

      <input
        className="form-control mb-2"
        placeholder="Designation"
        value={form.Designation}
        onChange={e => setForm({ ...form, Designation: e.target.value })}
      />

      <textarea
        className="form-control mb-2"
        placeholder="Message"
        value={form.Message}
        onChange={e => setForm({ ...form, Message: e.target.value })}
      />

      {getPreviewUrl() && (
        <div className="mb-3">
          <p className="mb-1">Photo Preview</p>

          <a
            href={getPreviewUrl()}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={getPreviewUrl()}
              alt="Preview"
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid #ccc",
                cursor: "pointer"
              }}
            />
          </a>

          <p style={{ fontSize: "0.85rem" }}>
            {photo ? photo.name : oldPhoto?.split("/").pop()}
          </p>
        </div>
      )}

      <input
        type="file"
        className="form-control mb-3"
        accept="image/*"
        onChange={e => setPhoto(e.target.files[0])}
      />

      <button className="btn btn-success">
        {editData ? "Update" : "Save"}
      </button>

    </form>
  );
};

export default OrgStructureForm;
